$(document).bind('_js_ready', function() {
	let $bandeau = $('.bandeau_page'),
		$alerte = $('#bandeau_alerte'),
		$container = $bandeau.children('.img'),
		$img = $container.find('img'),
		$video = $container.find('video'),
		$poster_video = $video.attr('poster');

	// Check si le media dans le bandeau est une image ou une video
		let $media;
		$video.length ? $media = $video : $media = $img;

	// Parallax
		function parallax() {

			// Ajuste le parallax si bandeau alerte
				let $scroll;
				$alerte.length ?
				$scroll = $(window).scrollTop() - $alerte.outerHeight() :
				$scroll = $(window).scrollTop();

			// Annule le parallax en responsive
				Foundation.MediaQuery.atLeast('large') ?
				$media.css({ 'transform' : 'translateY(' + $scroll/2 + 'px)' }) :
				$media.css({ 'transform' : 'translateY(0)' });

		} parallax();

		$(window).on('scroll resize', function() {
			parallax();
		});

		// Check si bandeau alerte
			if ($alerte.length) {
				// Augmente la taille du media en hauteur
					$media.css({ 'height' : $container.height() + ($alerte.outerHeight()/2) });

				// Ajuste les ancres des elements sticky a la fermeture
					$alerte.on('on.zf.toggler', function() {
						parallax();
						$media.css({'height' : 'inherit'});
						$('#data-sticky-header, #btn_acces_rapides').foundation('_calc', true);
					});
			}

	// Switch video to img in responsive
		function switch_to_img() {
			if ($('.bandeau_page video').length) {
				$video.addClass('hide');
				$container.append('<img src=' + $poster_video + ' width="' + $bandeau.width() + '" height="' + $bandeau.height() + '" alt="" />');
			}
		}

		function switch_to_video() {
			if ($('.bandeau_page video').length) {
				$video.removeClass('hide');
				$container.find('img').remove();
			}
		}

		if (Foundation.MediaQuery.is('small only')) { switch_to_img(); }

		$(window).on('resize', function() {
			// Si on est sur mobile et que la vidéo n'est pas cachée, on remplace la vidéo par l'image
				if (Foundation.MediaQuery.is('small only') && !$video.hasClass('hide')) { switch_to_img(); }

			// Si on est PAS sur mobile et que la vidéo est cachée, on remplace l'image par la vidéo
				if (Foundation.MediaQuery.atLeast('medium') && $video.hasClass('hide')) { switch_to_video(); }
		});
	});